import BaseEntityNew from 'client/components/core/BaseEntity/BaseEntityNew'
import React from 'react'
import { WebsiteButtonEntityInterface } from 'src/shared/entities/website-button/website-button.schema'
import { BaseEditorButton } from '../base-editor-button'

export interface WebsiteButtonProps {
  entity: WebsiteButtonEntityInterface
  isMoveUpAllowed: boolean
  isMoveDownAllowed: boolean
}

export const WebsiteButton = ({
  entity,
  isMoveUpAllowed,
  isMoveDownAllowed,
}: WebsiteButtonProps) => {
  return (
    <BaseEntityNew
      entity={entity}
      flex
      flexColumn
      isMoveDownAllowed={isMoveDownAllowed}
      isMoveUpAllowed={isMoveUpAllowed}
    >
      <BaseEditorButton entityOrSubEntity={entity}></BaseEditorButton>
    </BaseEntityNew>
  )
}
